
// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/user';
const ROOTS_DASHBOARD = '/app';
// const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  // loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  // registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  // verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: (verifyToken: string) => path(ROOTS_AUTH, `/verify/${verifyToken}`),
  // newPassword: path(ROOTS_AUTH, '/new-password'),
  newPassword: (verifyToken: string) => path(ROOTS_AUTH, `/new-password/${verifyToken}`),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  tnc: '/tnc',
  privacyPolicy: '/privacy-policy',
  // logout: '/privacy-policy',
};

export const PATH_DASHBOARD = {
  root: path(ROOTS_DASHBOARD, '/home'),
  app: path(ROOTS_DASHBOARD, '/home'),
  home: path(ROOTS_DASHBOARD, '/home'),
  // news: (name: string) => path(ROOTS_DASHBOARD, `/${name}`),

  news: {
    root: path(ROOTS_DASHBOARD, '/news'),
    notification: path(ROOTS_DASHBOARD, '/news/notification'),
    userAct: path(ROOTS_DASHBOARD, '/news/user-activity'),
    userFiles: path(ROOTS_DASHBOARD, '/news/user-files'),
  },

  kanban: path(ROOTS_DASHBOARD, '/kanban'),

  notifications: path(ROOTS_DASHBOARD, '/notifications'),


  explore: path(ROOTS_DASHBOARD, '/explore'),
  exploreType: (type: string) => path(ROOTS_DASHBOARD, `/explore?t=${type}`),
  exploreQuery: (keywords: string, type: string) => path(ROOTS_DASHBOARD, `/explore?k=${keywords}&t=${type}`),
  following: path(ROOTS_DASHBOARD, '/following'),
  profile: path(ROOTS_DASHBOARD, '/profile'),
  setting: path(ROOTS_DASHBOARD, '/setting'),
  logout: path(ROOTS_DASHBOARD, '/logout'),


  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  fileManager: path(ROOTS_DASHBOARD, '/files-manager'),
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    // banking: path(ROOTS_DASHBOARD, '/banking'),
    // booking: path(ROOTS_DASHBOARD, '/booking'),
    // file: path(ROOTS_DASHBOARD, '/file'),
  },

  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all'),
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    view: (name: string) => path(ROOTS_DASHBOARD, `/chat/${name}`),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    new: path(ROOTS_DASHBOARD, '/user/new'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    // profile: path(ROOTS_DASHBOARD, '/user/profile'),
    profile: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}`),

    profileFriends: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/following`),
    profileFollowers: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/followers`),
    profileBlog: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/blog`),
    profileFavorite: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/favorite`),
    profileFavoriteBlog: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/favorite/blog`),
    profileFavoritePost: (profileEmail: string) => path(ROOTS_DASHBOARD, `/profile/${profileEmail}/favorite/post`),


    userprofile: path(ROOTS_DASHBOARD, `/profile/`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    edit: (name: string) => path(ROOTS_DASHBOARD, `/user/${name}/edit`),
    // demoEdit: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
  },

  // invoice: {
  //   root: path(ROOTS_DASHBOARD, '/invoice'),
  //   list: path(ROOTS_DASHBOARD, '/invoice/list'),
  //   new: path(ROOTS_DASHBOARD, '/invoice/new'),
  //   view: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}`),
  //   edit: (id: string) => path(ROOTS_DASHBOARD, `/invoice/${id}/edit`),
  //   demoEdit: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1/edit'),
  //   demoView: path(ROOTS_DASHBOARD, '/invoice/e99f09a7-dd88-49d5-b1c8-1daf80c2d7b5'),
  // },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/explore'),
    // list: path(ROOTS_DASHBOARD, '/blog/list'),
    // new: path(ROOTS_DASHBOARD, '/blog/new'),
    view: (blogId: string) => path(ROOTS_DASHBOARD, `/blog/${blogId}`),
    // edit: (blogId: string) => path(ROOTS_DASHBOARD, `/blog/edit/${blogId}`),
    // demoView: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
  },
  myblog: {
    root: path(ROOTS_DASHBOARD, '/myblog'),
    edit: (blogId: string) => path(ROOTS_DASHBOARD, `/myblog/edit/${blogId}`),
    new: path(ROOTS_DASHBOARD, '/myblog/new'),
  },

  community: {
    root: path(ROOTS_DASHBOARD, '/community'),
    all: path(ROOTS_DASHBOARD, '/community/all'),
    explore: path(ROOTS_DASHBOARD, '/community/explore'),
  },
  post: {
    root: path(ROOTS_DASHBOARD, '/post'),
    // posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    // new: path(ROOTS_DASHBOARD, '/post/new'),
    view: (postId: string) => path(ROOTS_DASHBOARD, `/post/${postId}`),
    // demoView: path(ROOTS_DASHBOARD, '/post/apply-these-7-secret-techniques-to-improve-event'),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.google.com',
  changelog: 'https://docs.google.com/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
